import { Dispatch, SetStateAction, useEffect } from 'react';

export type UseResetFilterTemplatesWhenTemplateVmsChange = {
  setFilteredItems: Dispatch<SetStateAction<InventoryVirtualMachine[]>>;
  templateVms: InventoryVirtualMachine[];
};

export const useResetFilterTemplatesWhenTemplateVmsChange = ({
  setFilteredItems,
  templateVms,
}: UseResetFilterTemplatesWhenTemplateVmsChange): void => {
  useEffect(() => {
    setFilteredItems(templateVms);
  }, [setFilteredItems, templateVms]);
};
